import { normalizeRole } from './roleAccess';

// Keep this permanent page boundary aligned with
// api.resolution_room.permissions.AssuranceReadPermission. Operational
// Assurance deliberately does not reuse the optional tenant navigation map:
// the backend applies this allowlist independently from that map as well.
export const OPERATIONAL_ASSURANCE_READ_ROLES = Object.freeze([
  'admin',
  'analyst',
  'safety_officer',
  'accountable_manager',
  'anac',
]);

export function canReadOperationalAssurance(role) {
  return OPERATIONAL_ASSURANCE_READ_ROLES.includes(normalizeRole(role));
}
